import React, { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";
import "./RecentPoststyle.css";
import Search from "assets/search.svg";
import { useLanguage } from "LanguageContext";

const RecentPost = ({ blogData, small }) => {
  const [searchBlog, setsearchBlog] = useState("");
  const { selectedLanguage } = useLanguage();

  const searchValue = (value) => {
    setsearchBlog(value);
  };
  return (
    <div style={{ paddingBottom: small ? "20px" : "0px" }}>
      <div>
        <Box position="relative">
          <input
            type="text"
            onChange={(e) => searchValue(e.target.value)}
            placeholder="Search By Posts"
            style={{
              padding: "12px 49px",
              background: "none",
              border: "1px solid grey",
              color: "white",
            }}
            maxLength="15"
          />
          <img
            src={Search}
            alt="Search"
            style={{ position: "absolute", height: 16, top: 12, right: 115 }}
          />
        </Box>
      </div>
      <div
        style={{
          width: small ? "82%" : "70%",
          border: "1px solid grey",
          padding: small ? "10px" : "20px",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          marginLeft={small && SIZES.sixty}
        >
          <Text
            fontSize={small ? SIZES.fourteen : "25px"}
            textColor="white"
            fontWeight="bold"
            margin={"0px 0px"}
            cursor="pointer"
          >
            Recent Post
          </Text>
          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            {blogData
              .filter((item) => {
                if (searchBlog) {
                  if (
                    item?.attributes?.blog_title
                      ?.toLowerCase()
                      .includes(searchBlog?.toLowerCase())
                  )
                    return item;
                } else {
                  return item;
                }
              })

              .map((item, i) => (
                <Text
                  fontSize={small ? SIZES.twelve : "15px"}
                  fontWeight="bold"
                  width="fit-content"
                  cursor="pointer"
                  textColor={COLORS.primary}
                  name={i}
                  key={item?.id}
                  onClick={() =>
                    (window.location.href = `/${selectedLanguage}/blogs/${item?.attributes?.blog_slug}`)
                  }
                >
                  {item?.attributes?.blog_title}
                </Text>
              ))}
          </div>
        </Box>
      </div>
    </div>
  );
};

export default RecentPost;
